import { render, staticRenderFns } from "./UserCreateForm.vue?vue&type=template&id=072cbf30&"
import script from "./UserCreateForm.vue?vue&type=script&lang=js&"
export * from "./UserCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./UserCreateForm.vue?vue&type=style&index=0&id=072cbf30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports